import React, { useState } from 'react'
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore'

import { db } from '../../FirebaseInit'
import { useToast } from '../../context/ToastContext'

// CloseTicketModal
//
// Prompts the user (admin or customer) for a text reason before closing a
// ticket, then writes status='Closed' with the reason and a status-change
// timestamp. Both roles may close a ticket; the Firestore rules allow a
// customer to set their own ticket to Closed (and only Closed).
const CloseTicketModal = ({ ticketId, onClose, onClosed = () => {} }) => {
  const { showToast } = useToast()
  const [reason, setReason] = useState('')
  const [saving, setSaving] = useState(false)

  const handleConfirm = async () => {
    const trimmed = reason.trim()
    if (trimmed === '') return

    setSaving(true)
    try {
      await updateDoc(doc(db, 'tickets', ticketId), {
        status: 'Closed',
        closureReason: trimmed,
        statusChangedAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      })
      showToast('Ticket closed', 'green')
      onClosed()
      onClose()
    } catch (err) {
      console.error('Failed to close ticket:', err)
      showToast('Failed to close ticket', 'red')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg' role='dialog' aria-labelledby='close-ticket-title'>
        <h3 id='close-ticket-title' className='text-lg font-bold mb-2'>Close Ticket</h3>
        <p className='text-sm text-gray-700 mb-3'>
          Please provide a reason for closing this ticket. This will be shared with the ticket thread and included in the closing notification.
        </p>
        <textarea
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          rows={4}
          placeholder='Reason for closure...'
          disabled={saving}
          className='block w-full rounded border border-gray-300 p-2 text-sm text-left'
        />
        <div className='flex justify-end gap-2 mt-4'>
          <button
            type='button'
            onClick={onClose}
            disabled={saving}
            className='rounded border border-gray-300 px-4 py-1 text-sm hover:bg-gray-50'
          >
            Cancel
          </button>
          <button
            type='button'
            onClick={handleConfirm}
            disabled={saving || reason.trim() === ''}
            className='rounded bg-red-600 px-4 py-1 text-sm text-white hover:bg-red-700 disabled:bg-gray-300'
          >
            {saving ? 'Closing...' : 'Close Ticket'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CloseTicketModal
